import { ApiService } from '~/shared/api'
import { API_PREFIX } from '~/shared/const/request-services'
import { ResumesFilterModel } from '~/models/resumes'
import { unwrapToModels } from '~/shared/utils/response'
import type { ResumesRequestParams } from '~/types/resumes'

export class ResumesFiltersService extends ApiService {
  readonly urls = {
    filters: `${API_PREFIX}/resumes/filters`,
  }

  async getFilters(
    params: ResumesRequestParams,
    signal?: AbortSignal
  ): Promise<ResumesFilterModel[]> {
    const res = await this.http.request({ url: this.urls.filters, params, signal })

    return unwrapToModels(res.data, ResumesFilterModel)
  }
}
